<template>
  <div class="container">
    <!--注册页面-->
    <div class="dengl dengl_zc">
      <div class="zcy">
        <div class="zcya">
          <img src="@/view/images/logo1.png">
          <p>用户注册</p>
          <h6>已有账号<a href="javascript:void(0);" @click="login">立即登录</a></h6>
          <div class="clearfix"></div>
        </div>
        <div class="zcyb">
          <p :class="isgeren == 0 ? 'on' : ''" @click="isgr(0)">企业注册</p>
          <p :class="isgeren == 1 ? 'on' : ''" @click="isgr(1)">个人注册</p>
          <div class="clearfix"></div>
        </div>
        <div class="zcyc">
          <div class="zcyd" v-if="isgeren == 0">
            <div class="zcyda fl">
              <div class="zcyca">
                <p>企业名</p>
                <input class="input1" type="text" value="请输入企业名称" v-model="enterprise"
                       onfocus="if(value=='请输入企业名称') {value=''}" onblur="if (value=='') {value='请输入企业名称'}">
                <div class="clearfix"></div>
              </div>
              <div class="zcyca">
                <p>统一社会信用码</p>
                <input class="input1" type="text" value="请输入信用码" v-model="creditcode"
                       onfocus="if(value=='请输入信用码') {value=''}" onblur="if (value=='') {value='请输入信用码'}">
                <div class="clearfix"></div>
              </div>
              <div class="zcyca">
                <p>区域</p>
                <!--<input class="input1" type="text" value="请选择企业所在区域" v-model="region"-->
                <!--onfocus="if(value=='请选择企业所在区域') {value=''}" onblur="if (value=='') {value='请选择企业所在区域'}">-->
                <select class="input1" v-model="region" @change="changeProduct($event)">
                  <option v-for="(item,index) in province" :key="index" :value='item.id'>{{item.title}}</option>
                </select>
                <div class="clearfix"></div>
              </div>
              <div class="zcyca">
                <p>手机号</p>
                <input class="input1" type="text" value="请输入您的手机号" v-model.number="mobile"
                       onfocus="if(value=='请输入您的手机号') {value=''}" onblur="if (value=='') {value='请输入您的手机号'}">
                <div class="clearfix"></div>
              </div>
            </div>
            <div class="zcyda fr">
              <div class="zcyca">
                <p>设置密码</p>
                <input class="input1" type="text" v-model="password1" value="请输入您的密码"
                       onfocus="if(value=='请输入您的密码') {value=''}" onblur="if (value=='') {value='请输入您的密码'}">
                <div class="clearfix"></div>
              </div>
              <div class="zcyca">
                <p>重复密码</p>
                <input class="input1" type="text" v-model="password2" value="请再次输入密码"
                       onfocus="if(value=='请再次输入密码') {value=''}" onblur="if (value=='') {value='请再次输入密码'}">
                <div class="clearfix"></div>
              </div>
              <div class="zcyca">
                <p>邮箱</p>
                <input class="input1" type="text" v-model="email" value="请输入您的邮箱"
                       onfocus="if(value=='请输入您的邮箱') {value=''}" onblur="if (value=='') {value='请输入您的邮箱'}">
                <div class="clearfix"></div>
              </div>
              <div class="zcyca">
                <p>验证码</p>
                <input class="input1" type="text" v-model="code" value="请输入您的验证码"
                       onfocus="if(value=='请输入您的验证码') {value=''}" onblur="if (value=='') {value='请输入您的验证码'}">
                <span><a href="javascript:void(0);" @click="codesub">获取验证码</a></span>
                <div class="clearfix"></div>
              </div>
            </div>
            <div class="clearfix"></div>
          </div>
          <div class="zcyd zcyx" v-else>
            <div class="zcyda">
              <div class="zcyca">
                <p>手机号</p>
                <input class="input1" type="text" v-model.number="mobile" value="请输入您的手机号"
                       onfocus="if(value=='请输入您的手机号') {value=''}" onblur="if (value=='') {value='请输入您的手机号'}">
                <div class="clearfix"></div>
              </div>
              <div class="zcyca">
                <p>验证码</p>
                <input class="input1" type="text" v-model="code" value="请输入您的验证码"
                       onfocus="if(value=='请输入您的验证码') {value=''}" onblur="if (value=='') {value='请输入您的验证码'}">
                <span><a href="javascript:void(0)" @click="codesub">获取验证码</a></span>
                <div class="clearfix"></div>
              </div>
              <div class="zcyca">
                <p>设置密码</p>
                <input class="input1" type="text" v-model="password1" value="请输入您的密码"
                       onfocus="if(value=='请输入您的密码') {value=''}" onblur="if (value=='') {value='请输入您的密码'}">
                <div class="clearfix"></div>
              </div>
              <div class="zcyca">
                <p>重复密码</p>
                <input class="input1" type="text" v-model="password2" value="请再次输入密码"
                       onfocus="if(value=='请再次输入密码') {value=''}" onblur="if (value=='') {value='请再次输入密码'}">
                <div class="clearfix"></div>
              </div>

            </div>
          </div>
        </div>
        <div class="zcye">
          <input type="submit" @click="registerbtn" value="立即注册">
        </div>
        <div class="zcyf">
          <input type="checkbox">已阅读并同意<a href="#">《印工社用户服务协议》</a>和<a href="javascript:void(0);" @click="privacy">《隐私政策声明》</a>
          <p></p>
        </div>
      </div>
      <div class="yjd">
        <p>Copyright© 2019-2021 印工社（青岛）数字科技有限公司 All Rights Reserved<span>|</span><a
            href="https://beian.miit.gov.cn"
            target="_banck"
            style="corsor:pointer"
          >
            鲁ICP备20000134号-3</a
          ><span></span><a href="https://beian.mps.gov.cn/#/query/webSearch?code=37021402002207\" target="_banck">鲁公网安备 37021402002207号</a><span class="span1">|</span>网站建设：<a href="#">印工社</a></p>
      </div>
    </div>

  </div>
</template>

<script>
import $ from 'jquery';
// 在需要使用的页面中
export default {
  name: 'registerName',
  data() {
    return {
      isgeren: 0,
      mobile: '请输入您的手机号',
      code: '请输入您的验证码',
      password1: '请输入您的密码',
      password2: '请再次输入密码',
      enterprise: '请输入企业名称',
      creditcode: '请输入信用码',
      region: 810000,
      email: '请输入您的邮箱',
      province: [{ id: 810000, title: '北京' }, { id: 2, title: '上海' }, { id: 3, title: '广州' }, { id: 4, title: '四川' }],
    };
  },
  methods: {
    init() {
      const thisPointer = this;
      const url = `${process.env.API_HOST}/psl/provinces/get`; // HOME变量为已挂载的可跨域域名，这里将其拼接完，成为一个完整路径
      this.$axios({ // this代表vue对象，之前在入口文件中把axios挂载到了vue中，所以这里直接用this.$axios调用axios对象
        method: 'get',
        url,
        data: {},
      }).then((res) => {
        console.log(res, 'get');
        const json = res.data;
        if (json.code === 200) {
          thisPointer.province = json.message.data;
        }
      });
    },
    isgr(type) {
      this.isgeren = type;
    },
    privacy() {
      this.$router.push({ path: '/privacy' });
    },
    login() {
      this.$router.push({ path: '/login' });
    },
    changeProduct() {
      this.region = event.target.value; // 获取option对应的value值
    },
    codesub() {
      const thisPointer = this;
      const { mobile } = thisPointer;
      const prams = {
        phone: mobile,
      };
      const url = `${process.env.API_HOST}/psl/user/code/regist`; // HOME变量为已挂载的可跨域域名，这里将其拼接完，成为一个完整路径
      this.$axios({ // this代表vue对象，之前在入口文件中把axios挂载到了vue中，所以这里直接用this.$axios调用axios对象
        method: 'post',
        url,
        data: prams,
      }).then((res) => {
        const json = res.data;
        if (json.code === 200) {
          console.log(json.message.success, 'json.message.success');
          if (json.message.success) {
            thisPointer.$notify({
              title: '提示',
              message: json.message.message,
              type: 'success',
            });
          } else {
            thisPointer.$notify.error({
              title: '提示',
              message: json.message.message,
            });
          }
        }
      });
    },
    registerbtn() {
      const { isgeren } = this;
      const { mobile } = this;
      const { code } = this;
      const { password1 } = this;
      const { password2 } = this;
      if (mobile === '') {
        this.$message.error('手机号不能为空');
        return false;
      }
      if (!(/^1[3456789]\d{9}$/.test(mobile))) {
        this.$message.error('手机号格式错误');
        return false;
      }
      if (code === '') {
        this.$message.error('验证码不能为空');
        return false;
      }
      if (code.length !== 6) {
        this.$message.error('验证码为六位数字');
        return false;
      }
      if (password1 === '') {
        this.$message.error('密码不能为空');
        return false;
      }
      console.log(password1.length, 'len');
      if (password1.length >= 6 < 16) {

      } else {
        this.$message.error('请输入6-16位密码，支持数字字母下划线');
        return false;
      }
      if (password2 === '') {
        this.$message.error('密码不能为空');
        return false;
      }
      if (password2 !== password1) {
        this.$message.error('两次输入密码不匹配');
        return false;
      }
      if (isgeren === 0) {
        var thisPointer = this;
        const { enterprise } = thisPointer;
        const { creditcode } = thisPointer;
        const { region } = thisPointer;
        var { email } = thisPointer;
        if (enterprise === '') {
          this.$message.error('企业名称不能为空');
          return false;
        }
        if (creditcode === '') {
          this.$message.error('统一社会信用码不能为空');
          return false;
        }
        if (region === '') {
          this.$message.error('请选择企业所在区域');
          return false;
        }
        if (email === '') {
          this.$message.error('邮箱不能为空');
          return false;
        }
        const reg = /^([a-zA-Z0-9]+[-_\.]?)+@[a-zA-Z0-9]+\.[a-z]+$/;
        if (!reg.test(email)) {
          this.$message.error('请输入正确的邮箱地址');
          return false;
        }
        var prams = {
          teamName: enterprise,
          userName: mobile,
          email,
          phone: mobile,
          code,
          password: password1,
          password2,
          creditCode: creditcode,
          province: region,
        };
        var url = `${process.env.API_HOST}/psl/team/create`; // HOME变量为已挂载的可跨域域名，这里将其拼接完，成为一个完整路径
        this.$axios({ // this代表vue对象，之前在入口文件中把axios挂载到了vue中，所以这里直接用this.$axios调用axios对象
          method: 'post',
          url,
          data: prams,
        }).then((res) => {
          const json = res.data;
          if (json.code === 200) {
            thisPointer.$notify({
              title: '提示',
              message: json.message.message,
              type: 'success',
            });
            setTimeout(() => {
              thisPointer.login();
            }, 2000);
          }
        });
      } else {
        var thisPointer = this;
        const name = '1123';
        var email = '767857012@qq.com';
        var prams = {
          name: mobile,
          email: mobile,
          phone: mobile,
          code,
          password: password1,
          password2,
        };
        var url = `${process.env.API_HOST}/psl/user/regist`; // HOME变量为已挂载的可跨域域名，这里将其拼接完，成为一个完整路径
        this.$axios({ // this代表vue对象，之前在入口文件中把axios挂载到了vue中，所以这里直接用this.$axios调用axios对象
          method: 'post',
          url,
          data: prams,
        }).then((res) => {
          const json = res.data;
          if (json.code == 200) {
            if (json.message.success) {
              thisPointer.$notify({
                title: '提示',
                message: json.message.message,
                type: 'success',
              });
              setTimeout(() => {
                thisPointer.login();
              }, 2000);
            } else {
              thisPointer.$notify.error({
                title: '提示',
                message: json.message.message,
              });
            }
          }
        });
      }
    },
  },
  mounted() {

  },
  created() {
    this.init();
  },
};
</script>

<style scoped>
  .container {
    background-color: #273142;
    width: 100%;
    height: 110vh;
  }

  .dengl .yjd {
    margin-top: 15px;
  }

  .zcyca select {
    width: calc(95% - 120px);
    float: right;
    display: block;
    height: 49px;
    line-height: 47px;
    border: 1px solid #e5e5e5;
    padding-left: 16px;
    font-size: 14px;
    color: #979797;
    border-radius: 5px;
  }
</style>



// WEBPACK FOOTER //
// src/view/register.vue